import { STATIC_URL } from 'constants/all';

const logo = `${STATIC_URL}/images/pp-logo.svg`;

const Logo = (props) => <img {...props} src={logo} alt="PaperlessParts" />;

export default Logo;
